import fp from 'lodash/fp'
import {
  combine,
  withAsyncEffect,
  withStateHandlers,
  withCallbacks,
} from 'react-hooks-combine'

import LinkedSelectComponent from './component'

export const LinkedSelect = combine(
  withStateHandlers(
    {
      sportTypeSearch: '',
      tournamentSearch: '',
      sportType: null,
      tournament: null,
    },
    {
      setSportTypeSearch: ({ args: [sportTypeSearch] }) => ({
        sportTypeSearch,
      }),
      setTournamentSearch: ({ args: [tournamentSearch] }) => ({
        tournamentSearch,
      }),
      setSportType: ({ args: [sportType] }) => ({ sportType }),
      setTournament: ({ args: [tournament] }) => ({ tournament }),
    }
  ),
  withAsyncEffect({
    deps: ['sportTypeSearch'],
    dataName: 'sportTypeOptions',
    loadingName: 'loadingSportTypes',
    async asyncAction({ sportTypeSearch }, { loadSportTypes }) {
      return loadSportTypes({ search: sportTypeSearch })
    },
  }),
  withAsyncEffect({
    deps: ['sportType', 'tournamentSearch', 'tournament'],
    dataName: 'tournamentOptions',
    loadingName: 'loadingTournaments',
    async asyncAction({ sportType, tournamentSearch }, { loadTournaments }) {
      return loadTournaments({
        sportType: sportType?.id,
        search: tournamentSearch,
      })
    },
  }),
  withCallbacks(
    {
      onSportTypeInput: ({ setSportTypeSearch }) => {
        return fp.debounce(500, (search) => {
          setSportTypeSearch(search)
        })
      },

      onTournamentInput: ({ setTournamentSearch }) => {
        return fp.debounce(500, (search) => {
          setTournamentSearch(search)
        })
      },

      onChangeSportType: {
        deps: ['onChange'],
        func:
          ({ setSportType, setTournament }, { onChange }) =>
          ({ target: { value: sport } }) => {
            setSportType(sport)
            setTournament(null)

            const value = { sport, tournament: null }
            onChange({ target: { value } })
          },
      },

      onChangeTournament: {
        deps: ['sportType', 'onChange'],
        func:
          ({ sportType, setTournament }, { onChange }) =>
          ({ target: { value: tournament } }) => {
            setTournament(tournament)

            const value = { tournament, sport: sportType }
            onChange({ target: { value } })
          },
      },
    },
    []
  )
)(LinkedSelectComponent)
